
export class PackageDependenciesGraph {
    links: Array<INodeConnection>;
    nodes: Array<INode>;

    constructor() {
        this.nodes = [];
        this.links = [];
    }
}
